module.exports = __webpack_public_path__ + "static/img/mizrahi.1dbba7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/mizrahi.jpg
// module id = rrIp
// module chunks = 6